import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { IResume } from "../../../models/Resume";
import { Dialog } from "primereact/dialog";
import { Publish } from "../Publish";

interface Iprops {
    vendor_Company_ID?: number,
    cons_id?: number,
    open: boolean,
    hideDialog: () => void,
    toast: any,
}

export const Resumes = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IResume>, loading: boolean });

    const [publish, setPublish] = useState({ singleData: {}, open: false } as { singleData: { req_ID?: number }, open: boolean });
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };

    useEffect(() => {
        if (props.vendor_Company_ID && props.cons_id) loadTableData();
    }, [props.vendor_Company_ID, props.cons_id]);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Resume_Mast", "GET", null,
            `vendor_company_id=${props.vendor_Company_ID}&cons_id=${props.cons_id}`,
            props.toast);
        if (response) {
            const data: Array<IResume> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const downloadResume = async (path: string, consultant_email_id: string) => {
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/msword',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"Resume_Mast/download"}?path=${path}&consultant_email_id=${consultant_email_id}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${consultant_email_id}.docx`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const download = (rowData: IResume) => {
        return (
            <Button icon="pi pi-download" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => { if (rowData.resume_Path && rowData.consultant_Email_ID) downloadResume(rowData.resume_Path, rowData.consultant_Email_ID); }} />
        );
    };

    const req_Job_Title = (rowData: { req_ID: number, req_Job_Title: string }) => {
        return (<span onClick={() => setPublish({ singleData: { req_ID: rowData.req_ID }, open: true })}
            className="cursor-pointer text-cyan-700 underline">
            {rowData.req_Job_Title}
        </span>);
    };

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Resumes" className="p-fluid" draggable={false} onHide={props.hideDialog}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={tableData.tableData}
                emptyMessage="No Resumes found."
                loading={tableData.loading}
            >
                <Column field="consultant_Name" header="Consultant" />
                <Column field="req_ID" header="Req" />
                <Column field="req_Job_Title" header="Job Tittle" body={req_Job_Title} />
                <Column field="sales" header="Sales" />
                <Column field="recruiter" header="Recruiter" />
                <Column field="sub_Vendor" header="Sub Vendor" />
                <Column header="Download" body={download} />
            </DataTable>
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
        </Dialog>
    );
}
